import { gql } from "@apollo/client";

export const getJudgeListQuery = gql`
  query GetJudgeList(
    $pageNumber: Int!
    $pageSize: Int!
    $search: String
    $level: [String!]
    $location: String
    $city: String
    $state: String
    $judgeStatus : String
  ) {
    getJudgeList(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
      level: $level
      location: $location
      city: $city
      state: $state
      judgeStatus : $judgeStatus
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        name
        email
        location_address
        phone_number
        distance_travel
        noofTrialJudged
        level
        zipCode
        judgeStatus
        authId
        city
        state
      }
    }
  }
`;

export const UPDATE_JUDGE_STATUS_GQL = gql`
  mutation UpdateJudgeStatus($authId: String!, $judgeStatus: String!) {
    updateJudgeStatus(authId: $authId, judgeStatus: $judgeStatus) {
      message
    }
  }
`;

export const updateJudgeLevel = gql`
  mutation UpdateJudgeLevel($authId: String!, $level: [String!]!) {
    updateJudgeLevel(authId: $authId, level: $level) {
      message
    }
  }
`;

export const DOWNLOAD_JUDGES_REPORT = gql`
  query GenerateAllJudgesReport {
    generateAllJudgesReport {
      downloadUrl
    }
  }
`;
